import { createFileRoute } from '@tanstack/react-router'
import { ApplicantDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import ViewApplicantDialog from '@/routes/_app/-dialogs/view-applicant'

export const Route = createFileRoute('/@modal/applicants/$applicantId')({
  params: idParams('applicantId'),
  staticData: { slotScope: '/_app/offers/_list/$offerId' },
  pendingComponent: ApplicantDialogPending,
  component: ViewApplicantSlot,
})

function ViewApplicantSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <ViewApplicantDialog applicantId={Number(params.applicantId)} {...slot} />
}
